(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-affiliate-estimator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psn-estimator')) {
    customElements.define('psn-estimator', class extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.k = { aov: parseFloat(d.aov) || 0, share: parseFloat(d.share) || 0, factor: parseFloat(d.factor) || 0, months: parseFloat(d.months) || 0 };
        try {
          this.fmt = new Intl.NumberFormat(d.locale || undefined, { style: 'currency', currency: d.currency || 'USD' });
        } catch (e) {
          this.fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' });
        }
        this.refs = this.querySelector('[data-input="refs"]');
        this.rate = this.querySelector('[data-input="rate"]');
        this.out = {};
        this.querySelectorAll('[data-out]').forEach((el) => { this.out[el.dataset.out] = el; });
        this.update = this.update.bind(this);
        this.refs.addEventListener('input', this.update);
        this.rate.addEventListener('input', this.update);
        this.update();
      }
      update() {
        const r = Number(this.refs.value);
        const ratePct = Number(this.rate.value);
        const rate = ratePct / 100;
        const k = this.k;
        const first = r * k.aov * rate;
        const recurring = r * k.share * k.aov * k.factor * rate * k.months;
        const total = first + recurring;
        this.out.refs.textContent = r;
        this.out.rate.textContent = ratePct + '%';
        this.rate.setAttribute('aria-valuetext', ratePct + '%');
        this.out.first.textContent = this.fmt.format(first);
        this.out.recurring.textContent = this.fmt.format(recurring);
        this.out.total.textContent = this.fmt.format(total);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-cart-drawer"]) return;
  try {
    
  (() => {
    window.PSN = window.PSN || {};
    if (!customElements.get('psn-js')) customElements.define('psn-js', class extends HTMLElement {});
    if (customElements.get('psn-cart-drawer')) return;

    const getDrawer = () => PSN._cartDrawer;
    const json = (res) => res.json().catch(() => ({}));
    const errorText = (data) => data.description || data.message || getDrawer().dataset.errorText;

    class PsnCartDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-psn-cart-dialog]');
        this.sectionId = this.dataset.sectionId;
        this.queue = Promise.resolve();
        this.promoOpen = false;
        PSN._cartDrawer = this;
        PSN.cart = {
          open: () => getDrawer().open(),
          close: () => getDrawer().close(),
          refresh: () => getDrawer().refresh(),
        };

        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
      }

      disconnectedCallback() {
        document.documentElement.classList.remove('psn-scroll-lock');
      }

      get panel() {
        return this.querySelector('[data-psn-rerender]');
      }

      open() {
        if (this.dialog.open) return;
        this.returnFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('psn-scroll-lock');
        requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
        const close = this.querySelector('[data-psn-cart-close]');
        if (close) close.focus();
      }

      close() {
        if (!this.dialog.open) return;
        this.dialog.classList.remove('is-open');
        const done = () => {
          this.dialog.close();
          document.documentElement.classList.remove('psn-scroll-lock');
          if (this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus();
        };
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        reduce ? done() : setTimeout(done, 320);
      }

      run(task) {
        this.queue = this.queue.then(task, task);
        return this.queue;
      }

      sectionIds() {
        const ids = [this.sectionId];
        document.querySelectorAll('[data-psn-rerender]').forEach((el) => {
          const id = el.dataset.psnRerender;
          if (!ids.includes(id)) ids.push(id);
        });
        return ids.slice(0, 5);
      }

      setBusy(busy) {
        document.querySelectorAll('[data-psn-rerender]').forEach((el) => el.setAttribute('aria-busy', busy));
      }

      showError(message) {
        document.querySelectorAll('[data-psn-cart-error]').forEach((el) => {
          el.textContent = message || '';
          el.hidden = !message;
        });
      }

      render(sections) {
        if (!sections) return;
        const active = document.activeElement;
        const focusEl = active && active.closest ? active.closest('[data-psn-focus]') : null;
        const focusKey = focusEl ? focusEl.dataset.psnFocus : null;
        const focusInDrawer = this.contains(active);
        const parser = new DOMParser();

        Object.keys(sections).forEach((id) => {
          const html = sections[id];
          if (!html) return;
          const fresh = parser.parseFromString(html, 'text/html').querySelector(`[data-psn-rerender="${CSS.escape(id)}"]`);
          if (!fresh) return;
          document.querySelectorAll(`[data-psn-rerender="${CSS.escape(id)}"]`).forEach((target) => {
            const oldShip = target.querySelector('[data-psn-ship]');
            const oldFree = oldShip ? oldShip.dataset.free === 'true' : null;
            const oldFill = oldShip ? oldShip.querySelector('.psn-ship__fill').style.width : null;
            const hadFocus = target.contains(active);
            target.innerHTML = fresh.innerHTML;
            this.animateShip(target, oldFree, oldFill);
            if (hadFocus && focusKey) {
              const next = target.querySelector(`[data-psn-focus="${CSS.escape(focusKey)}"]`);
              if (next) next.focus();
            }
          });
        });

        this.syncPromo();
        if (focusInDrawer && this.dialog.open && !this.contains(document.activeElement)) {
          const close = this.querySelector('[data-psn-cart-close]');
          if (close) close.focus();
        }
      }

      animateShip(root, oldFree, oldFill) {
        const ship = root.querySelector('[data-psn-ship]');
        if (!ship) return;
        if (oldFree === false && ship.dataset.free === 'true') ship.classList.add('is-flash');
        const fill = ship.querySelector('.psn-ship__fill');
        if (oldFill && fill) {
          const target = fill.style.width;
          fill.style.transition = 'none';
          fill.style.width = oldFill;
          fill.offsetWidth;
          fill.style.transition = '';
          fill.style.width = target;
        }
      }

      syncPromo() {
        const toggle = this.querySelector('[data-psn-promo-toggle]');
        const form = this.querySelector('[data-psn-promo]');
        if (!toggle || !form) return;
        toggle.setAttribute('aria-expanded', this.promoOpen);
        form.hidden = !this.promoOpen;
      }

      afterCart(cart) {
        this.cart = cart;
        const count = cart.item_count || 0;
        document.querySelectorAll('[data-psn-cart-count]').forEach((el) => {
          el.textContent = count;
          el.hidden = count === 0;
        });
        document.dispatchEvent(new CustomEvent('psn:cart:updated', { detail: cart }));
      }

      async fetchCart() {
        const res = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        const cart = await json(res);
        this.afterCart(cart);
        return cart;
      }

      refresh() {
        return this.run(async () => {
          const url = `${window.location.pathname}?sections=${encodeURIComponent(this.sectionIds().join(','))}`;
          const [sections] = await Promise.all([
            fetch(url).then(json),
            this.fetchCart(),
          ]);
          this.render(sections);
        });
      }

      add(form, submitter) {
        return this.run(async () => {
          const inDrawer = this.contains(form);
          const button = submitter || form.querySelector('[type="submit"]');
          if (button) {
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
          }
          const formError = form.querySelector('[data-psn-add-error]');
          if (formError) formError.hidden = true;
          this.showError('');

          const body = new FormData(form);
          if (body.has('selling_plan') && !body.get('selling_plan')) body.delete('selling_plan');
          body.append('sections', this.sectionIds().join(','));
          body.append('sections_url', window.location.pathname);

          try {
            const res = await fetch(`${this.dataset.cartAddUrl}.js`, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body,
            });
            const data = await json(res);
            if (!res.ok || data.status) {
              if (inDrawer) this.showError(errorText(data));
              else this.formError(form, errorText(data));
              return;
            }
            this.render(data.sections);
            await this.fetchCart();
            this.open();
          } catch (err) {
            if (inDrawer) this.showError(errorText({}));
            else this.formError(form, errorText({}));
          } finally {
            if (button && button.isConnected) {
              button.disabled = false;
              button.removeAttribute('aria-busy');
            }
          }
        });
      }

      formError(form, message) {
        let el = form.querySelector('[data-psn-add-error]');
        if (!el) {
          el = document.createElement('p');
          el.className = 'psn-add-error';
          el.setAttribute('role', 'alert');
          el.setAttribute('data-psn-add-error', '');
          form.appendChild(el);
        }
        el.textContent = message;
        el.hidden = false;
      }

      async post(url, payload) {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            ...payload,
            sections: this.sectionIds().join(','),
            sections_url: window.location.pathname,
          }),
        });
        const data = await json(res);
        if (!res.ok || data.status) {
          const err = new Error(errorText(data));
          err.status = res.status;
          throw err;
        }
        return data;
      }

      change(payload) {
        return this.run(async () => {
          this.setBusy(true);
          this.showError('');
          try {
            const cart = await this.post(`${this.dataset.cartChangeUrl}.js`, payload);
            this.render(cart.sections);
            delete cart.sections;
            this.afterCart(cart);
          } catch (err) {
            this.showError(err.message);
          } finally {
            this.setBusy(false);
          }
        });
      }

      applyDiscount(code, remove) {
        return this.run(async () => {
          const current = ((this.cart && this.cart.discount_codes) || [])
            .filter((d) => d.applicable)
            .map((d) => d.code)
            .filter((c) => c.toUpperCase() !== code.toUpperCase());
          const codes = remove ? current : current.concat(code);
          this.setBusy(true);
          let cart;
          try {
            cart = await this.post(`${this.dataset.cartUpdateUrl}.js`, { discount: codes.join(',') });
          } catch (err) {
            if (!remove) {
              window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(this.dataset.cartUrl)}`;
            } else {
              this.showError(err.message);
            }
            return;
          } finally {
            this.setBusy(false);
          }
          this.render(cart.sections);
          delete cart.sections;
          this.afterCart(cart);
          if (remove) return;
          const match = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
          const ok = !!(match && match.applicable);
          const msg = this.querySelector('[data-psn-promo-msg]');
          if (msg) {
            msg.textContent = ok ? this.dataset.codeApplied : this.dataset.codeInvalid;
            msg.classList.toggle('is-error', !ok);
            msg.hidden = false;
          }
          if (!ok) {
            const input = this.querySelector('[data-psn-promo] input');
            if (input) {
              input.value = code;
              input.focus();
            }
          }
        });
      }
    }

    customElements.define('psn-cart-drawer', PsnCartDrawer);

    document.addEventListener('submit', (e) => {
      const drawer = getDrawer();
      const form = e.target;
      if (!drawer || !(form instanceof HTMLFormElement)) return;
      if (form.matches('form[data-psn-add]')) {
        e.preventDefault();
        drawer.add(form, e.submitter);
      } else if (form.matches('[data-psn-promo]')) {
        e.preventDefault();
        const code = (form.elements.discount.value || '').trim();
        if (code) drawer.applyDiscount(code, false);
      }
    });

    document.addEventListener('click', (e) => {
      const drawer = getDrawer();
      if (!drawer || !e.target.closest) return;
      const t = e.target;

      const opener = t.closest('[data-psn-cart-open]');
      if (opener) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        drawer.open();
        return;
      }
      if (t.closest('[data-psn-cart-close]')) {
        drawer.close();
        return;
      }
      const qty = t.closest('[data-psn-line-qty]');
      if (qty) {
        e.preventDefault();
        drawer.change({ id: qty.dataset.key, quantity: Math.max(0, parseInt(qty.dataset.psnLineQty, 10) || 0) });
        return;
      }
      const plan = t.closest('[data-psn-line-plan]');
      if (plan) {
        const id = plan.dataset.psnLinePlan;
        drawer.change({
          id: plan.dataset.key,
          quantity: parseInt(plan.dataset.qty, 10) || 1,
          selling_plan: id ? parseInt(id, 10) : null,
        });
        return;
      }
      const promoToggle = t.closest('[data-psn-promo-toggle]');
      if (promoToggle) {
        drawer.promoOpen = !drawer.promoOpen;
        drawer.syncPromo();
        if (drawer.promoOpen) {
          const input = drawer.querySelector('[data-psn-promo] input');
          if (input) input.focus();
        }
        return;
      }
      const removeCode = t.closest('[data-psn-discount-remove]');
      if (removeCode) drawer.applyDiscount(removeCode.dataset.psnDiscountRemove, true);
    });

    document.addEventListener('change', (e) => {
      const input = e.target.closest && e.target.closest('[data-psn-line-input]');
      const drawer = getDrawer();
      if (!input || !drawer) return;
      drawer.change({ id: input.dataset.key, quantity: Math.max(0, parseInt(input.value, 10) || 0) });
    });

    document.addEventListener('shopify:section:select', (e) => {
      const drawer = getDrawer();
      if (drawer && e.detail.sectionId === drawer.sectionId) drawer.open();
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const drawer = getDrawer();
      if (drawer && e.detail.sectionId === drawer.sectionId) drawer.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-contact-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psn-contact-form')) {
    customElements.define('psn-contact-form', class extends HTMLElement {
      connectedCallback() {
        const success = this.querySelector('[data-psn-success]');
        if (success) {
          // Keep the box the height the form had, so the page doesn't jump and the message isn't missed.
          let h = 0;
          try { h = Number(sessionStorage.getItem('psn-cs-h-' + success.closest('form').id)) || 0; } catch (e) {}
          if (h) this.style.minHeight = h + 'px';
        }
        if (success && /contact_posted=true/.test(window.location.search)) {
          this.scrollIntoView({ block: 'center' });
          success.focus({ preventScroll: true });
        }
        const form = this.querySelector('form');
        if (!form) return;
        form.noValidate = true;
        const emailRe = (window.PSN && window.PSN.EMAIL_RE) || /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
        form.addEventListener('submit', (e) => {
          let firstBad = null;
          form.querySelectorAll('input:not([type="hidden"]), select').forEach((field) => {
            const value = field.value.trim();
            let msg = '';
            if (field.required && !value) msg = 'This field is required';
            else if (field.type === 'email' && value && !emailRe.test(value)) msg = 'Enter a valid email address';
            const error = document.getElementById(field.id + '-error');
            field.setAttribute('aria-invalid', msg ? 'true' : 'false');
            if (error) { error.textContent = msg; error.hidden = !msg; }
            if (msg && !firstBad) firstBad = field;
          });
          if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
          try { sessionStorage.setItem('psn-cs-h-' + form.id, String(this.offsetHeight)); } catch (err) {}
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-footer"]) return;
  try {
    
  if (!customElements.get('psn-rail')) {
    customElements.define('psn-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.psn-rail__track');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.querySelectorAll('.psn-rail__nav').forEach((btn) => btn.addEventListener('click', () => {
          this.track.scrollBy({ left: Number(btn.dataset.dir) * this.track.clientWidth * 0.8 });
        }));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.hidden = this.track.scrollLeft <= 2;
        this.next.hidden = this.track.scrollLeft >= max;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-guide-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psn-guide')) {
    customElements.define('psn-guide', class extends HTMLElement {
      connectedCallback() {
        this.cover = this.querySelector('[data-psn-guide-cover]');
        if (!this.cover || !('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this.update(); });
        };
        this.update();
        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.update();
          } else {
            window.removeEventListener('scroll', this.onScroll);
          }
        });
        this.io.observe(this);
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
      update() {
        const vh = window.innerHeight;
        const top = this.cover.getBoundingClientRect().top;
        const p = Math.max(0, Math.min(1, (vh - top) / (vh * 0.9)));
        this.style.setProperty('--psn-tilt', p.toFixed(3));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-journey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.jrReady) return;
      root.dataset.jrReady = '1';
      const path = root.querySelector('[data-jr-path]');
      const trail = root.querySelector('[data-jr-trail]');
      const particle = root.querySelector('[data-jr-particle]');
      const ol = root.querySelector('[data-jr-steps]');
      const steps = [...root.querySelectorAll('[data-jr-step]')];
      const stations = [...root.querySelectorAll('[data-jr-station]')];
      const count = root.querySelector('[data-jr-count]');
      const n = Math.min(steps.length, stations.length);
      if (!path || n < 2) return;
      const total = path.getTotalLength();
      trail.style.strokeDasharray = total;
      const lens = stations.slice(0, n).map((st) => {
        const x = +st.dataset.x, y = +st.dataset.y;
        let best = 0, bestD = Infinity;
        for (let l = 0; l <= total; l += 2) {
          const p = path.getPointAtLength(l), d = (p.x - x) ** 2 + (p.y - y) ** 2;
          if (d < bestD) { bestD = d; best = l; }
        }
        return best;
      });
      const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
      let active = -1;
      const setActive = (a) => {
        if (a === active) return;
        active = a;
        steps.forEach((s, i) => s.classList.toggle('is-current', i === a));
        stations.forEach((s, i) => { s.classList.toggle('is-current', i === a); s.classList.toggle('is-reached', i <= a); });
        if (count) count.textContent = String(a + 1).padStart(2, '0');
      };
      const draw = (p) => {
        const u = clamp(p * n - 0.5, 0, n - 1);
        const i = Math.min(n - 2, Math.floor(u));
        const g = clamp((u - i - 0.2) / 0.6, 0, 1);
        const e = g < .5 ? 2 * g * g : 1 - 2 * (1 - g) * (1 - g);
        const L = lens[i] + (lens[i + 1] - lens[i]) * e;
        const pt = path.getPointAtLength(L);
        particle.setAttribute('transform', `translate(${pt.x} ${pt.y})`);
        trail.style.strokeDashoffset = total - L;
        setActive(Math.round(u));
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        trail.style.strokeDashoffset = 0;
        stations.forEach((s) => s.classList.add('is-reached'));
        return;
      }
      const scrub = parseFloat(root.dataset.scrub || '0.8');
      let target = 0, current = 0, raf = 0, last = 0;
      // Reading line: middle of the screen. The diagram is hidden on phones (CSS), so this only matters on desktop.
      const progress = () => {
        const r = ol.getBoundingClientRect();
        const line = innerHeight / 2;
        return clamp((line - r.top) / r.height, 0, 1);
      };
      const tick = (t) => {
        const dt = last ? (t - last) / 1000 : 0.016; last = t;
        const k = scrub > 0 ? 1 - Math.exp(-dt / (scrub / 4)) : 1;
        current += (target - current) * k;
        if (Math.abs(target - current) < 0.0005) current = target;
        draw(current);
        raf = current === target ? 0 : requestAnimationFrame(tick);
        if (!raf) last = 0;
      };
      const onScroll = () => { target = progress(); if (!raf) raf = requestAnimationFrame(tick); };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
      current = target = progress(); draw(current);
    };
    const all = () => document.querySelectorAll('[data-psn-journey]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-psn-journey]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-lab-batches"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.psn-lab-batches').forEach((root) => {
    const pills = root.querySelectorAll('[data-filter]');
    pills.forEach((pill) => pill.addEventListener('click', () => {
      pills.forEach((p) => p.setAttribute('aria-pressed', String(p === pill)));
      root.querySelectorAll('tbody tr').forEach((row) => { row.hidden = !!pill.dataset.filter && row.dataset.product !== pill.dataset.filter; });
    }));
    root.querySelectorAll('[data-lot]').forEach((btn) => btn.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('psn:lot', { detail: { lot: btn.dataset.lot, scroll: true, fromTable: true } }));
    }));
    // A lookup (or ?lot= link) narrows the table to that lot; Clear or "All products" shows every row again.
    const narrow = (lot) => {
      pills.forEach((p) => p.setAttribute('aria-pressed', String(!lot && !p.dataset.filter)));
      root.querySelectorAll('tbody tr').forEach((row) => { row.hidden = !!lot && row.querySelector('[data-lot]').dataset.lot !== lot; });
    };
    document.addEventListener('psn:lot', (e) => { if (!e.detail.fromTable) narrow(e.detail.lot); });
    const urlLot = String(new URLSearchParams(location.search).get('lot') || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (urlLot && root.querySelector(`[data-lot="${CSS.escape(urlLot)}"]`)) narrow(urlLot);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-lab-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psn-lab-result')) {
    customElements.define('psn-lab-result', class extends HTMLElement {
      connectedCallback() {
        this.inner = this.querySelector('.psn-lab-result__inner');
        this.headingEl = this.querySelector('.psn-lab-result__title');
        this.querySelector('[data-psn-lot-clear]').addEventListener('click', () => document.dispatchEvent(new CustomEvent('psn:lot', { detail: { lot: null } })));
        document.addEventListener('psn:lot', (e) => this.show(e.detail.lot, e.detail.scroll));
        const lot = String(new URLSearchParams(location.search).get('lot') || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (lot) document.dispatchEvent(new CustomEvent('psn:lot', { detail: { lot, scroll: true } }));
      }
      show(lot, scroll) {
        const card = lot && this.querySelector(`[data-lot="${CSS.escape(lot)}"]`);
        this.querySelectorAll('[data-lot]').forEach((el) => (el.hidden = el !== card));
        this.inner.hidden = !card;
        const url = new URL(location.href);
        if (card) url.searchParams.set('lot', lot); else url.searchParams.delete('lot');
        history.replaceState(null, '', url);
        if (!card) return;
        this.querySelector('[data-psn-lot-label]').textContent = lot;
        if (scroll) {
          this.headingEl.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          this.headingEl.focus({ preventScroll: true });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-main-article"]) return;
  try {
    
  (() => {
    const SKIP = 'a, h1, h2, h3, h4, h5, h6, figcaption, button, sup';
    const escape = (t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const newTab = (a, label) => {
      a.target = '_blank';
      a.rel = 'noopener';
      if (a.querySelector('.psn-visually-hidden')) return;
      const hidden = document.createElement('span');
      hidden.className = 'psn-visually-hidden';
      hidden.textContent = ` ${label}`;
      a.append(hidden);
    };
    document.querySelectorAll('script[data-psn-product-links]').forEach((data) => {
      const prose = data.closest('.psn-article__body')?.querySelector('.psn-prose');
      if (!prose) return;
      const linked = new Set();
      prose.querySelectorAll('a[href]').forEach((a) => {
        const path = new URL(a.href, location.href).pathname;
        if (!path.includes('/products/')) return;
        linked.add(path);
        newTab(a, data.dataset.newTab);
      });
      // ponytail: first mention per product only; linking every mention reads as spam to readers and search engines.
      for (const { url, terms } of JSON.parse(data.textContent)) {
        if (linked.has(url) || !terms?.length) continue;
        const re = new RegExp(`\\b(${[...terms].sort((x, y) => y.length - x.length).map(escape).join('|')})\\b`, 'i');
        const walker = document.createTreeWalker(prose, NodeFilter.SHOW_TEXT, {
          acceptNode: (n) => (n.parentElement.closest(SKIP) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
        });
        for (let node; (node = walker.nextNode()); ) {
          const m = re.exec(node.data);
          if (!m) continue;
          const word = node.splitText(m.index);
          word.splitText(m[0].length);
          const a = document.createElement('a');
          a.href = url;
          word.replaceWith(a);
          a.append(word);
          newTab(a, data.dataset.newTab);
          linked.add(url);
          break;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-main-blog"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-psn-load-more]');
    if (!link || !window.fetch || !window.DOMParser) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;

    const grid = document.querySelector('[data-psn-blog-grid]');
    const wrap = link.closest('[data-psn-blog-more]');
    const label = link.querySelector('[data-psn-load-more-label]');
    const original = label ? label.textContent : '';
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', link.dataset.sectionId);

    link.setAttribute('aria-busy', 'true');
    if (label) label.textContent = link.dataset.loadingLabel;

    try {
      const res = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const items = doc.querySelectorAll('[data-psn-blog-grid] > *');
      const start = grid.children.length;
      items.forEach((item) => grid.appendChild(document.importNode(item, true)));

      const next = doc.querySelector('[data-psn-load-more]');
      if (next) {
        link.href = next.getAttribute('href');
        link.removeAttribute('aria-busy');
        if (label) label.textContent = original;
      } else {
        wrap.remove();
      }

      const appended = grid.children[start];
      const focusTarget = appended && appended.querySelector('a[href]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      if (window.PSN && PSN.initReveal) PSN.initReveal(grid);
    } catch (err) {
      window.location.href = link.href;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-main-product-apparel"]) return;
  try {
    
  if (!customElements.get('psn-product-apparel')) {
    class PsnProductApparel extends HTMLElement {
      // Long descriptions start collapsed (260px, faded) with a Read more / Show less toggle.
      initReadMore() {
        const wrap = this.querySelector('[data-psn-more]');
        if (!wrap) return;
        const desc = wrap.querySelector('.psn-pdpa__desc');
        const btn = wrap.querySelector('.psn-pdpa__more');
        if (desc.scrollHeight <= 340) return;
        wrap.classList.add('is-clamped');
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const open = wrap.classList.toggle('is-clamped') === false;
          btn.setAttribute('aria-expanded', String(open));
          btn.textContent = open ? btn.dataset.lessLabel : btn.dataset.moreLabel;
          if (!open && wrap.getBoundingClientRect().top < 0) wrap.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }

      connectedCallback() {
        this.initReadMore();
        try {
          this.variants = JSON.parse(this.querySelector('[data-psn-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.fieldsets = [...this.querySelectorAll('[data-option-index]')];
        this.select = this.querySelector('[data-variant-input]');

        this.addEventListener('click', (e) => {
          const thumb = e.target.closest('[data-thumb]');
          if (thumb) this.showMedia(thumb.dataset.thumb);
        });
        this.addEventListener('change', (e) => {
          const fs = e.target.closest('[data-option-index]');
          if (fs) this.onOptionChange(Number(fs.dataset.optionIndex), true);
        });
        if (this.fieldsets.length) this.onOptionChange(0, false);
      }

      selected() {
        return this.fieldsets.map((fs) => {
          const input = fs.querySelector('input:checked');
          return input ? input.value : null;
        });
      }

      matches(variant, values, upTo) {
        for (let i = 0; i < upTo; i++) if (variant.options[i] !== values[i]) return false;
        return true;
      }

      // Options are resolved in order: a value is enabled when an available variant exists with it and the earlier selections.
      // After a change, later options that no longer form an available combination jump to the first one that does.
      onOptionChange(changedIndex, userAction) {
        const values = this.selected();
        this.fieldsets.forEach((fs, i) => {
          const inputs = [...fs.querySelectorAll('input')];
          inputs.forEach((input) => {
            const candidate = values.slice();
            candidate[i] = input.value;
            const ok = this.variants.some((v) => v.available && this.matches(v, candidate, i) && v.options[i] === input.value);
            input.disabled = !ok;
            input.closest('label').classList.toggle('is-unavailable', !ok);
          });
          if (i > changedIndex || !userAction) {
            const current = fs.querySelector('input:checked');
            if (!current || current.disabled) {
              const next = inputs.find((input) => !input.disabled);
              if (next) {
                next.checked = true;
                values[i] = next.value;
              }
            }
          }
          const label = fs.querySelector('[data-selected-value]');
          if (label) label.textContent = values[i] || '';
        });

        const variant = this.variants.find((v) => this.matches(v, values, values.length));
        this.render(variant, userAction);
      }

      render(variant, userAction) {
        const btn = this.querySelector('[data-add-button]');
        const price = this.querySelector('[data-price]');
        const compare = this.querySelector('[data-compare]');
        if (!variant) {
          if (btn) {
            btn.disabled = true;
            btn.textContent = this.dataset.unavailable;
          }
          return;
        }
        if (this.select) this.select.value = String(variant.id);
        if (price) price.textContent = this.money.format(variant.price / 100);
        if (compare) {
          compare.hidden = !(variant.compare > variant.price);
          compare.textContent = this.money.format(variant.compare / 100);
        }
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOut;
        }
        if (userAction) {
          if (variant.media) this.showMedia(variant.media);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      showMedia(id) {
        const slides = this.querySelectorAll('[data-media-id]');
        if (![...slides].some((s) => s.dataset.mediaId === String(id))) return;
        slides.forEach((s) => (s.hidden = s.dataset.mediaId !== String(id)));
        this.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.thumb === String(id))));
      }
    }
    customElements.define('psn-product-apparel', PsnProductApparel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-main-product"]) return;
  try {
    
  if (!customElements.get('psn-product')) {
    class PsnProduct extends HTMLElement {
      connectedCallback() {
        try {
          this.variants = JSON.parse(this.querySelector('[data-psn-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.qty = this.querySelector('[name="quantity"]');
        this.variantInput = this.querySelector('[data-variant-input]');

        this.addEventListener('click', (e) => {
          const thumb = e.target.closest('[data-thumb]');
          if (thumb) this.showMedia(thumb.dataset.thumb);
          const step = e.target.closest('[data-qty-step]');
          if (step && this.qty) {
            this.qty.value = this.clamp(parseInt(this.qty.value, 10) + parseInt(step.dataset.qtyStep, 10));
            this.update();
          }
        });
        this.addEventListener('change', (e) => {
          if (e.target === this.variantInput) {
            const v = this.currentVariant();
            if (v && v.media) this.showMedia(v.media);
            const url = new URL(window.location.href);
            url.searchParams.set('variant', this.variantInput.value);
            window.history.replaceState({}, '', url.toString());
          }
          if (e.target === this.qty) this.qty.value = this.clamp(parseInt(this.qty.value, 10));
          this.update();
        });
        this.addEventListener('input', (e) => {
          if (e.target === this.qty) this.update();
        });
        this.update();
      }

      clamp(n) {
        const max = parseInt(this.qty.max, 10) || 99;
        return Math.min(max, Math.max(1, isNaN(n) ? 1 : n));
      }

      format(cents) {
        return this.money.format(cents / 100);
      }

      currentVariant() {
        const id = this.variantInput ? Number(this.variantInput.value) : null;
        return this.variants.find((v) => v.id === id) || this.variants[0];
      }

      showMedia(id) {
        const slides = this.querySelectorAll('[data-media-id]');
        if (![...slides].some((s) => s.dataset.mediaId === String(id))) return;
        slides.forEach((s) => (s.hidden = s.dataset.mediaId !== String(id)));
        this.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.thumb === String(id))));
      }

      update() {
        const v = this.currentVariant();
        if (!v) return;
        const checked = this.querySelector('[name="selling_plan"]:checked');
        const planId = checked ? checked.value : '';
        const unit = planId && v.plans[planId] != null ? v.plans[planId] : v.price;
        const qty = this.qty ? this.clamp(parseInt(this.qty.value, 10)) : 1;
        const total = unit * qty;

        this.querySelectorAll('[data-price-once]').forEach((el) => (el.textContent = this.format(v.price)));
        this.querySelectorAll('[data-price-plan]').forEach((el) => {
          const p = v.plans[el.dataset.pricePlan];
          el.textContent = this.format(p != null ? p : v.price);
        });
        this.querySelectorAll('[data-points]').forEach((el) => (el.textContent = Math.floor(total / 100)));

        const dec = this.querySelector('[data-qty-step="-1"]');
        if (dec) dec.disabled = qty <= 1;

        const btn = this.querySelector('[data-add-button]');
        if (btn && !btn.hasAttribute('data-coming-soon')) {
          btn.disabled = !v.available;
          if (v.available) {
            btn.textContent = this.dataset.addLabel + ' · ';
            const span = document.createElement('span');
            span.dataset.lineTotal = '';
            span.textContent = this.format(total);
            btn.appendChild(span);
          } else {
            btn.textContent = this.dataset.soldOut;
          }
        }
      }
    }
    customElements.define('psn-product', PsnProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-page-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.psnScrollLinks) {
    window.psnScrollLinks = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-psn-scroll]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      var focusable = target.querySelector('input, select, textarea, button');
      if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, reduce ? 0 : 500);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psn-reviews-page"]) return;
  try {
    
  if (!customElements.get('psn-reviews')) {
    customElements.define('psn-reviews', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-list]');
        if (!this.list) return;
        this.cards = Array.from(this.list.querySelectorAll('.psn-review'));
        this.empty = this.list.querySelector('[data-empty]');
        this.count = this.querySelector('[data-count]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.rating = this.querySelector('[data-filter="rating"]');
        this.sort = this.querySelector('[data-filter="sort"]');
        this.bars = Array.from(this.querySelectorAll('.psn-rvp__bar'));
        this.state = { tab: '', rating: '', sort: 'recent' };

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (e) => {
            let next = null;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = this.tabs[(i + 1) % this.tabs.length];
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
            else if (e.key === 'Home') next = this.tabs[0];
            else if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
            if (!next) return;
            e.preventDefault();
            this.selectTab(next);
            next.focus();
          });
        });
        [this.rating, this.sort].forEach((el) => {
          if (el) el.addEventListener('change', () => { this.state[el.dataset.filter] = el.value; this.render(); });
        });
        this.bars.forEach((bar) => {
          bar.addEventListener('click', () => {
            const star = bar.dataset.star;
            this.state.rating = this.state.rating === star ? '' : star;
            if (this.rating) this.rating.value = this.state.rating;
            this.render();
          });
        });
        this.render();
      }

      selectTab(tab) {
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.list.setAttribute('aria-labelledby', tab.id);
        this.state.tab = tab.dataset.tab;
        this.render();
      }

      render() {
        const st = this.state;
        const shown = this.cards.filter((c) =>
          (!st.tab || c.dataset.tab === st.tab) &&
          (!st.rating || c.dataset.rating === st.rating)
        );
        const byDate = (a, b) => (b.dataset.date || '').localeCompare(a.dataset.date || '') || a.dataset.index - b.dataset.index;
        const sorted = this.cards.slice().sort((a, b) => {
          if (st.sort === 'high') return b.dataset.rating - a.dataset.rating || byDate(a, b);
          if (st.sort === 'low') return a.dataset.rating - b.dataset.rating || byDate(a, b);
          return byDate(a, b);
        });
        sorted.forEach((c) => {
          c.hidden = !shown.includes(c);
          this.list.insertBefore(c, this.empty);
        });
        if (this.empty) this.empty.hidden = shown.length > 0;
        if (this.count) {
          this.count.textContent = (this.dataset.countTemplate || '')
            .replace('[shown]', shown.length)
            .replace('[total]', this.dataset.total);
        }
        this.bars.forEach((b) => b.setAttribute('aria-pressed', b.dataset.star === st.rating ? 'true' : 'false'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
